"use strict";
/**
* RxJs + EventBus
*
*
* @langversion TypeScript 2.0
* @tiptext
*
*/
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var torxemitteroperator_1 = require("./torxemitteroperator");
function rxEmit(a, b) {
    var eventObj = typeof a == 'object' ? a : { eventName: a, map: b };
    if (eventObj.name)
        eventObj.eventName = eventObj.name;
    if (eventObj.event)
        eventObj.eventName = eventObj.event;
    return this.lift(new torxemitteroperator_1.ToRxEmitterOperator(eventObj));
}
exports.rxEmit = rxEmit;
Observable_1.Observable.prototype.rxEmit = rxEmit;
//# sourceMappingURL=rxemit.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxemitter/rxemit.js
// module id = 1315
// module chunks = 0